export const getImageSizeFilterStyle = () => ({
  imageSizeFilterDowndown: {
    padding: 24,
    pointerEvents: 'auto',

    '& .dropdown-title': {
      fontSize: 20,
      fontWeight: 600,
      lineHeight: '20px',
    },

    '& .dropdown-value-input': {
      // maxWidth: 120,
      marginTop: 21,
    },
  },
});
